import { css } from "@linaria/core";

export const wrapper = css`
  display: flex;
  gap: 20px;

  & > * {
    flex-basis: 50%;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    & > * {
      flex-basis: 100%;
    }
  }
`;
